var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFootball2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18ZM3.46154 4.15385L4.15385 6.92308L1.38462 10.3846L2.07692 12.4615L5.53846 13.1538L7.61538 16.6154H9.69231L11.7692 13.1538L15.9231 11.7692V9.69231L13.8462 7.61539V3.46154L11.7692 2.07692L10.0385 3.46154H7.61538L5.53846 2.42308L3.46154 4.15385Z",
    fill: "#AFAFAF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.23047 9.00019L8.30739 6.23096H9.69201L11.7689 9.00019L10.7305 11.7694H7.26893L6.23047 9.00019Z",
    fill: "#AFAFAF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFootball2);
export default __webpack_public_path__ + "static/media/Football2.ae87c6c9a969d3b4d947ea8ca2c3228e.svg";
export { ForwardRef as ReactComponent };